<template>
  <!-- 写字楼卡片 -->
  <div class="CardBuilding">
    <div class="item_content">
      <div class="content_img">
        <van-image
          height="100%"
          width="100%"
          :src="detailData.videoList.length > 0 ?  detailData.videoList[0].thumbnailUrl : detailData.coverImageUrl"
          fit="cover"
        />
      </div>
      <div class="content_detail">
        <div class="fs16 line1">
          {{ detailData.name }}
        </div>
        <div class="fs15 color666">
          {{ detailData.district }}•{{ detailData.address }}
        </div>
        <div class="detail_number">
          <div class="number">
            <div class="fs15">{{ detailData.monthlyRent }}元/月</div>
            <div class="fs14 color666 m-l15">{{ detailData.area }}㎡</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, Image } from "vant";
export default {
  name: "CardBuilding",
  props: ["detailData"],
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
  },
};
</script>

<style lang="less">
// 写字楼卡片
.CardBuilding {
  display: flex;
  flex-direction: column;
  padding: 0px 20px;

  .item_content {
    display: flex;
    flex-direction: row;
    padding: 10px 0px;
    border-bottom: 1px solid #f1f1f1;

    .content_img {
      position: relative;
      width: 120px;
      height: 80px;
      border-radius: 3px;
      overflow: hidden;
    }

    .content_detail {
      width: 250px;
      display: flex;
      flex-flow: column; //垂直排列
      justify-content: space-between; //两端对齐
      margin-left: 10px;

      /deep/ .detail_tag {
        margin-right: 5px;

        .van-tag--plain {
          padding: 3px 5px;
        }
      }

      .detail_number {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: flex-end;

        .number {
          display: flex;
          flex-direction: row;
          align-items: flex-end;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/home/components/CardBuilding.vue